// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsDental = {
  benefits_section_dental: {
    contentful_name: '[DEFAULT] Benefits Section - Dental',
    preventive_header: '预防性',
    basic_header: '基础',
    major_header: '专业',
    preventive_care: '预防保健',
    basic_care: '基础护理',
    major_care: '重大护理',
    orthodontia_header: '正畸治疗',
    coinsurance_level: '{x}%已覆盖',
    copays_apply: '需支付共付额',
    coverage_details_header: '保障详情',
    preventive_example_list_preface: '预防性护理包括以下内容:{x}',
    basic_example_list_preface: '基本护理包括以下内容：{x}',
    major_example_list_preface: '主要护理包括以下内容:{x}',
    orthodontia_covers: '本计划如何承保正畸治疗',
    deductible: '免赔额',
    lifetime_maximum: '终身最高限额',
    covers_adults_and_children: '为成人和儿童提供保障',
    covers_children_only: '儿童可享受的保障范围',
    ortho_deductible_integrated: '整体牙科免赔额适用于正畸治疗',
    ortho_deductible_none: '正畸治疗无需自付免赔额',
    per_person: '每人{x}',
    copay_adults: '{x}成人版',
    copay_children: '儿童自付费用 {x}',
    has_predeductible_label: '并且免除自付额',
    no_predeductible_label: '在满足免赔额后',
  },
};
